"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var api_1 = require("../api");
var utils_1 = require("../utils");
exports.track = function (name, event, store) {
  if (event === void 0) {
    event = {};
  }
  if (store === void 0) {
    store = false;
  }
  if (store) {
    var eventKey = "ths_widget.tracking." + name + "." + JSON.stringify(event);
    if (localStorage.getItem(eventKey)) {
      utils_1.log("Skipping event [" + name + "]. Event previously sent.");
      return Promise.resolve();
    }
    localStorage.setItem(eventKey, 'true');
  }
  utils_1.log("Event: [" + JSON.stringify(__assign({
    name: name
  }, event, {
    user: utils_1.getUser()
  })) + "]");
  return utils_1.isDebugEnabled() ? Promise.resolve() : api_1.sendEvent([__assign({
    name: name
  }, event, {
    user: utils_1.getUser()
  })]).then(function (response) {
    return response.text();
  }).then(function (text) {
    utils_1.log("Event [" + name + "] sent. Status: " + text);
  }).catch(function (err) {
    utils_1.log("Error sending event: [" + name + "]");
  });
};